import React, {Suspense} from 'react';
import PropTypes from 'prop-types';

const RealComponent = React.lazy(() => import(/* webpackChunkName: "hogwarts_dash_monaco" */ '../fragments/HogwartsDashMonaco.react.js'));

const HogwartsDashMonaco = (props) => {
    return (
        <Suspense fallback={<div>Loading Editor...</div>}>
            <RealComponent {...props}/>
        </Suspense>
    );
};

// ⚠️ 极其重要：哪怕是壳子，这里也必须定义 propTypes！
// 因为 Dash 的 Python 代码生成器是来这里扫参数的！
HogwartsDashMonaco.defaultProps = {
    value: '',
    language: 'python',
    theme: 'light',
    height: '400px',
    readOnly: false,
    errorMarkers: null
};

HogwartsDashMonaco.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    language: PropTypes.string,
    theme: PropTypes.string,
    height: PropTypes.string,
    readOnly: PropTypes.bool,
    errorMarkers: PropTypes.array,
    setProps: PropTypes.func
};

export default HogwartsDashMonaco;
export const defaultProps = HogwartsDashMonaco.defaultProps;
export const propTypes = HogwartsDashMonaco.propTypes;